import { render, staticRenderFns } from "./ConversationActionsTemplate.vue?vue&type=template&id=05deb25b&"
import script from "./ConversationActionsTemplate.vue?vue&type=script&lang=js&"
export * from "./ConversationActionsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports